import React from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Chip,
  CircularProgress,
} from "@material-ui/core";
import translate from "i18n/translate";
import { SrCurrency, Typography } from "components/common";

const Deposits = ({ deposits, loading }) => {
  const getStatusChip = (status, id) => {
    const chips = {
      pending: (
        <Chip key={id} label={translate("common.pending")} color="default" />
      ),
      canceled: (
        <Chip key={id} label={translate("common.canceled")} color="secondary" />
      ),
      applied: (
        <Chip key={id} label={translate("common.applied")} color="primary" />
      ),
    };

    return chips[status];
  };

  if (loading) {
    return (
      <Box display="flex">
        <CircularProgress />
      </Box>
    );
  }

  return deposits?.rows?.length ? (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              {translate("resume.deposits.date")}
            </TableCell>
            <TableCell align="center">
              {translate("resume.deposits.name")}
            </TableCell>
            <TableCell align="center">
              {translate("resume.deposits.status")}
            </TableCell>
            <TableCell align="center">
              {translate("resume.deposits.bank")}
            </TableCell>
            <TableCell align="center">
              {translate("resume.deposits.total")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deposits.rows.map((row) => (
            <TableRow key={row.key}>
              <TableCell align="center">{row.date}</TableCell>
              <TableCell align="center">{row.name}</TableCell>
              <TableCell align="center">
                {getStatusChip(row.status, row.key)}
              </TableCell>
              <TableCell align="center">{row.sellChannel}</TableCell>
              <TableCell align="center">
                <SrCurrency value={row.total} currency={row.currency} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Grid container item justifyContent="center">
      {/* TODO: move to component */}
      <Box mb={12} mt={4} mx={4}>
        <Typography variant="h4Regular" align="center">
          {translate("resume.noWithdrawalsToShow")}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Deposits;
